import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';

// Thunk to fetch top categories
export const getAllCategoriesThunk = createAsyncThunk(
  'categories/getCategories',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.getAllCategory(); 
      
      return response.data?.data;
    } catch (error) {
        console.log(error);  
    }
  }
);

// Slice for categories
const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    categories: [],
    filteredCategories:[],
    loading: false,
    error: null,
  },
  reducers: {
    setCategories:(state,action)=>{
         state.filteredCategories = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCategoriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(getAllCategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {setCategories} = categoriesSlice.actions
export default categoriesSlice.reducer;

